import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { catchAsync, FormField, IS_SUCCESS_RESPONSE } from "src/helpers";
import {
  INITIAL_NEWSLETTER_SUBSCRIBE_FORM_VALUES,
  NEWSLETTER_SUBSCRIBE_FORM_FIELDS,
  NEWSLETTER_SUBSCRIBE_FORM_VALIDATION_SCHEMA,
} from "./modules";
import RenderFormComponents from "src/shadcn/components/custom/RenderFormComponents";
import { Button } from "src/shadcn/components/ui";
import {
  createScheduleCallbackApiRequest,
  updateNewsletterRequestApiRequest,
} from "src/services/requests/ScheduleCall";
import LoadingDialog from "src/shadcn/components/custom/LoadingDialog";
import CustomeDialog from "src/shadcn/components/custom/CustomeDialog";
import { useLocation, useNavigate } from "react-router-dom";

const NewSeltterForm = () => {
  const [isLoading, setisLoading] = useState<boolean>(false);
  const [isOpenSuccessDialog, setIsOpenSuccessDialog] = useState<boolean>(false);
  const [subscribedData, setSubscribData] = useState<any>({});
  const { search } = useLocation();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: INITIAL_NEWSLETTER_SUBSCRIBE_FORM_VALUES,
    validationSchema: NEWSLETTER_SUBSCRIBE_FORM_VALIDATION_SCHEMA,
    onSubmit(values, formikHelpers) {
      const { phonenumber, ...val } = values;
      const postdata = {
        ...val,
        phonenumber: String(phonenumber),
      };
      handleRequest(postdata);
    },
  });

  useEffect(() => {
    const params = search && search?.split("?")[1].split("&");

    let searchParams: any = {};

    params &&
      params.forEach((o: any) => {
        let splitParam = o?.split("=");
        searchParams[splitParam[0]] = splitParam[1];
      });
    setSubscribData(searchParams && searchParams);
    if (searchParams && Object.keys(searchParams)?.length > 0) {
      let { campaign_name, name, ...rest } = searchParams;
      formik.setValues({ campaign_name: decodeURIComponent(campaign_name), ...rest });
    } else return;

    return () => {};
  }, [search]);

  const handleRequest = catchAsync(
    async (postdata: any) => {
      setisLoading(true);
      return await updateNewsletterRequestApiRequest(postdata);
    },
    (result: any) => {
      if (IS_SUCCESS_RESPONSE(result)) {
        setIsOpenSuccessDialog(true);
        setisLoading(false);
      }
    },
    () => {
      setisLoading(false);
    }
  );

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        {NEWSLETTER_SUBSCRIBE_FORM_FIELDS.map((field: FormField) => {
          return (
            <div>
              <RenderFormComponents
                key={`new-schedule-meet-form-${field.dataKey}`}
                formik={formik}
                value={formik.values[field.dataKey as keyof object]}
                {...field}
                onChange={(e: any) => formik.setFieldValue(field.dataKey, e)}
              />
            </div>
          );
        })}
        <div className="flex justify-center py-4">
          <Button isLoading={isLoading} className="w-full">
            Subscribe
          </Button>
        </div>
      </form>
      <LoadingDialog isOpen={isLoading} />
      <CustomeDialog isOpen={isOpenSuccessDialog} headerTitle={""} hideDefaultCancle onSubmit={() => navigate("/")}>
        <div className="space-y-2 mb-4">
          <div className="text-xl font-bold text-center text-black">Thank you for Subscribing us !</div>
          <p className="mb-2 text-center">Our representative will connect you soon.</p>
        </div>
      </CustomeDialog>
    </>
  );
};

export default NewSeltterForm;
